<template>
  <v-flex>
    <notify-custom :showNotify="show" :type="tipoNotify"
    :message="msgNotify" :icontext="iconNotify" :color="color">
    </notify-custom>
    <v-data-table :page="page" :pageCount="numberOfPages"
    :options.sync="options" :server-items-length="totalItems"
      :loading="loading" :headers="headers" :items="objetos"
      sort-by="created_at" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ txtMessages.txtOrdersNoSync }} {{ nameDropshipper }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-menu v-model="menuDateFrom" :close-on-content-click="false"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateFrom" label="Desde"
                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                v-on="on" hide-details class="mx-2" style="max-width:150px">
              </v-text-field>
            </template>
            <v-date-picker v-model="dateFrom"
              @input="menuDateFrom = false; listar()">
            </v-date-picker>
          </v-menu>
          <v-menu v-model="menuDateTo" :close-on-content-click="false"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateTo" label="Hasta"
                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                v-on="on" hide-details class="mx-2" style="max-width:150px">
              </v-text-field>
            </template>
            <v-date-picker v-model="dateTo"
              @input="menuDateTo = false; listar()">
            </v-date-picker>
          </v-menu>
          <v-spacer></v-spacer>
          <v-divider class="mx-4" inset vertical></v-divider>
          <vue-excel-xlsx :data="objExcel" :columns="columns"
          :file-name="'ordersDropshipper'" :file-type="'xlsx'"
            :sheet-name="'orders'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" class="ma-2 white--text" fab small v-bind="attrs" v-on="on">
                  <v-icon dark>
                    file_download
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ txtMessages.txtExport }}</span>
            </v-tooltip>
          </vue-excel-xlsx>
          <v-dialog v-model="showModalSync" max-width="900px">
            <v-card>
              <v-card-title v-if="resultSync.status" class="headline">
                STATUS: {{ resultSync.status }}
              </v-card-title>
              <v-card-text v-if="resultSync.message">MSG: {{ resultSync.message }}</v-card-text>
              <v-card-text v-if="resultSync.order">ORDER: {{ resultSync.order.name }}</v-card-text>
              <v-list-item v-for="item in resultSync.order.line_items" :key="item.id" two-line>
                <v-list-item-content>
                  <v-list-item-title>{{ item.vendor }} {{ item.sku }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.title }} ({{ item.price }})</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="showModalAddress" max-width="700px" persistent>
            <v-card>
              <v-card-title class="headline">
                Falta la direccion de envio
              </v-card-title>
              <v-card-text>
                <v-alert dense text type="warning" class="mb-4">
                  Shopify no entrego los datos del comprador para esta orden.
                  <span v-if="addressForm.probableCause">
                    <br><small>{{ addressForm.probableCause }}</small>
                  </span>
                </v-alert>
                <p v-if="addressForm.missingFields.length" class="caption mb-4">
                  Campos faltantes: <strong>{{ addressForm.missingFields.join(', ') }}</strong>
                </p>
                <v-form ref="addressFormRef">
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="addressForm.first_name" label="Nombre *"
                        :rules="[requiredRule]" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="addressForm.last_name" label="Apellido *"
                        :rules="[requiredRule]" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="addressForm.address1" label="Direccion *"
                        :rules="[requiredRule]" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="addressForm.address2"
                        label="Apartamento, suite, etc. (opcional)" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="5">
                      <v-text-field v-model="addressForm.city" label="Ciudad *"
                        :rules="[requiredRule]" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="addressForm.province_code" label="Estado *"
                        :rules="[requiredRule]" hint="Codigo de 2 letras, ej: FL"
                        persistent-hint dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="addressForm.zip" label="Codigo postal *"
                        :rules="[requiredRule]" dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="addressForm.country_code" label="Pais *"
                        :rules="[requiredRule]" hint="Codigo de 2 letras, ej: US"
                        persistent-hint dense outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="addressForm.phone" label="Telefono (opcional)"
                        dense outlined></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-alert dense text type="info" class="mb-0">
                  Verifica los datos con el cliente antes de continuar. La orden se va a
                  despachar fisicamente a esta direccion.
                </v-alert>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="closeAddressModal()" :disabled="addressLoading">
                  Cancelar
                </v-btn>
                <v-btn color="primary" @click="syncWithManualAddress()"
                  :loading="addressLoading">
                  Sincronizar orden
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.created_at="{ item }">
        <td>
          {{ $moment(item.created_at).format('YYYY-MM-DD HH:MM') }}
        </td>
      </template>
      <template v-slot:item.register_logs="{ item }">
        <td>
          <h5>{{ item.register_logs.length >= 1 ? item.register_logs[0].date : '' }}</h5>
          {{ item.register_logs.length >= 1 ? item.register_logs[0].content : '' }}
          ({{ item.register_logs.length }})
        </td>
      </template>
      <template v-slot:item.shipping_lines="{ item }">
        <td>
          <p v-for="v in item.shipping_lines" :key="v.number">{{ v.code }}</p>
        </td>
      </template>
      <template v-slot:item.financial_status="{ item }">
        <td>
          <v-chip small :color="financialStatusColor(item.financial_status)" dark>
            {{ item.financial_status }}
          </v-chip>
        </td>
      </template>
      <template v-slot:item.options="{ item }">
        <template>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon :color="item.can_sync ? '#ff9800' : '#9e9e9e'" class="mr-2" v-bind="attrs"
              v-on="on" :loading="item.loading"
                :disabled="item.loading || !item.can_sync" @click="syncOrderDropshipper(item.id)">
                <v-icon> mdi-sync
                </v-icon>
              </v-btn>
            </template>
            <span>{{ item.can_sync ? txtMessages.txtSyncOrder : item.no_sync_reason }}</span>
          </v-tooltip>
        </template>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="listar()">
          {{ txtMessages.txtReset }}
        </v-btn>
      </template>
    </v-data-table>
  </v-flex>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import notifyCustom from './partials/notifyDialog.vue';
import langMsg from '../config/generalMessages';

export default {
  components: {
    'notify-custom': notifyCustom,
  },
  data() {
    return {
      txtMessages: langMsg,
      dialog: false,
      showModalSync: false,
      resultSync: {
        order: {
          name: null,
          line_items: [],
          total_price: null,
        },
      },
      // --- direccion manual: Shopify no entrega PII en tiendas plan Basic ---
      showModalAddress: false,
      addressLoading: false,
      pendingOrderId: null,
      addressForm: {
        first_name: '',
        last_name: '',
        address1: '',
        address2: '',
        city: '',
        province_code: '',
        zip: '',
        country_code: 'US',
        phone: '',
        missingFields: [],
        probableCause: '',
      },
      rangeTime: 25,
      rangeUnit: 'days',
      rangeUnitOptions: ['days', 'weeks', 'months'],
      search: '',
      dateFrom: '',
      dateTo: '',
      menuDateFrom: false,
      menuDateTo: false,
      objetos: [],
      objExcel: [],
      dialogDelete: false,
      page: 1,
      numberOfPages: 10,
      options: {},
      totalItems: 0,
      headers: [
        {
          text: langMsg.txtCreationDate, align: 'start', value: 'created_at', sortable: false,
        },
        { text: 'order name Dropshipper', value: 'name', sortable: false },
        { text: 'order id', value: 'id', sortable: false },
        { text: langMsg.txtOrderPriceDropshipper, value: 'total_price', sortable: false },
        { text: 'Payment status', value: 'financial_status', sortable: false },
        { text: langMsg.txtOrderShippingLine, value: 'shipping_lines', sortable: false },
        { text: langMsg.txtOrderNote, value: 'note', sortable: false },
        { text: langMsg.logs, value: 'register_logs', sortable: false },
        { text: langMsg.txtOptions, value: 'options', sortable: false },
      ],
      columns: [
        { label: langMsg.txtCreationDate, field: 'created_at' },
        { label: langMsg.txtOrderName, field: 'name' },
        { label: langMsg.txtOrderIdProvider, field: 'id' },
        { label: langMsg.txtOrderPriceDropshipper, field: 'total_price' },
        { label: langMsg.txtOrderShippingLine, field: 'shipping_lines' },
        { label: langMsg.txtOrderNote, field: 'note' },
      ],
      // eslint-disable-next-line
      nameDropshipper: '',
      nameConfig: '',
      idDropshipper: '',
      data: {},
      // --- events data ---
      loading: false,

      tipoNotify: 'Info',
      msgNotify: '--',
      show: false,
      color: 'primary',
      iconNotify: 'info',
    };
  },
  computed: {
  },
  watch: {
    dialog(val) {
      return val || this.close();
    },
    dialogDelete(val) {
      return val || this.closeDelete();
    },
    options: {
      handler() {
        if (this._mounted) this.listar();
      },
    },
    deep: true,
  },
  created() {
    this.$store.commit('SET_LAYOUT', 'principal-layout');
  },
  mounted() {
    axios.defaults.headers.common.authorization = this.$store.state.token;
    this.idDropshipper = this.$route.params.id;
    this.dateTo = moment().format('YYYY-MM-DD');
    this.dateFrom = moment().subtract(25, 'days').format('YYYY-MM-DD');
    if (this.$store.state.token) {
      this.getOne(this.idDropshipper);
      this.listar();
    }
    this._mounted = true;
  },

  methods: {
    notifyMessage(type, message) {
      this.tipoNotify = type;
      this.msgNotify = message;
      this.show = true;
      if (type === 'Info') {
        this.color = 'primary';
        this.iconNotify = 'info';
      } else if (type === 'Success') {
        this.color = 'green';
        this.icontext = 'check_circle';
      } else if (type === 'Error') {
        this.color = 'red';
        this.icontext = 'error';
      }
    },
    requiredRule(value) {
      return !!value || 'Requerido';
    },
    syncOrderDropshipper(idOrder) {
      this.loading = true;
      // eslint-disable-next-line
      axios.get(`order/sync/single/${this.idDropshipper}/${idOrder}`).then((response) => {
        this.loading = false;
        // Shopify no entrego la direccion del comprador: se pide a mano antes de crear
        if (response.data && response.data.needs_shipping_address) {
          this.openAddressModal(idOrder, response.data);
          return 'needs-address';
        }
        this.showModalSync = true;
        this.resultSync = response.data;
        return 'ok';
      }).catch((err) => {
        this.loading = false;
        this.errorMsg = '';
        this.showError = 0;
        this.notifyMessage('Error', err.response.data.message);
        return 'fail';
      });
    },
    openAddressModal(idOrder, data) {
      const received = data.shipping_address_received || {};
      this.pendingOrderId = idOrder;
      this.addressForm = {
        // lo que Shopify si entrego queda precargado; el resto lo completa el operador
        first_name: received.first_name || '',
        last_name: received.last_name || '',
        address1: received.address1 || '',
        address2: received.address2 || '',
        city: received.city || '',
        province_code: received.province_code || received.province || '',
        zip: received.zip || '',
        country_code: received.country_code || received.country || 'US',
        phone: received.phone || '',
        missingFields: data.missing_fields || [],
        probableCause: data.probable_cause || '',
      };
      this.showModalAddress = true;
    },
    closeAddressModal() {
      this.showModalAddress = false;
      this.pendingOrderId = null;
      if (this.$refs.addressFormRef) this.$refs.addressFormRef.resetValidation();
    },
    syncWithManualAddress() {
      if (!this.$refs.addressFormRef.validate()) return;
      this.addressLoading = true;
      const payload = {
        shipping_address: {
          first_name: this.addressForm.first_name,
          last_name: this.addressForm.last_name,
          address1: this.addressForm.address1,
          address2: this.addressForm.address2,
          city: this.addressForm.city,
          province_code: this.addressForm.province_code,
          zip: this.addressForm.zip,
          country_code: this.addressForm.country_code,
          phone: this.addressForm.phone,
        },
      };
      // eslint-disable-next-line
      axios.post(`order/sync/single/${this.idDropshipper}/${this.pendingOrderId}`, payload).then((response) => {
        this.addressLoading = false;
        if (response.data && response.data.needs_shipping_address) {
          this.addressForm.missingFields = response.data.missing_fields || [];
          this.notifyMessage('Error', response.data.message || 'La direccion sigue incompleta');
          return 'incomplete';
        }
        this.closeAddressModal();
        this.showModalSync = true;
        this.resultSync = response.data;
        this.listar();
        return 'ok';
      }).catch((err) => {
        this.addressLoading = false;
        this.notifyMessage('Error', err.response?.data?.message || 'Error al sincronizar');
        return 'fail';
      });
    },
    getOne(id) {
      if (axios.defaults.headers.common.authorization) {
        axios.get(`dropshipper/get/${id}`).then((res) => {
          this.data = res.data.body;
          this.nameDropshipper = `${this.data.name} - ${this.data.contact.name}`;
          this.nameConfig = this.data.config.shop;
          return 'ok';
        });
      }
    },
    listar() {
      this.loading = true;
      this.idDropshipper = this.$route.params.id;
      this.objetos = [];
      const params = `date_from=${this.dateFrom}&date_to=${this.dateTo}`;
      let urlConsult = `order/no-sync/${this.idDropshipper}?${params}`;
      const search = this.search === '' ? false : this.search;
      if (search) urlConsult = `${urlConsult}&search=${search}`;
      if (axios.defaults.headers.common.authorization) {
        axios.get(urlConsult).then((res) => {
          this.loading = false;
          this.objetos = res.data.body;
          this.objExcel = res.data.body.map((a) => {
            const doc = { ...a };
            doc.created_at = moment(a.created_at).format('YYYY-MM-DD HH:MM');
            return doc;
          });
          this.totalItems = res.data.body.length;
          this.numberOfPages = 1;
        });
      }
    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    clean() {
      const empty = '';
      this.nameDropshipper = empty;
    },
    getColor(result) {
      return result ? 'green' : 'red';
    },
    financialStatusColor(status) {
      const map = {
        paid: 'green',
        pending: 'orange',
        partially_paid: 'orange',
        refunded: 'red',
        voided: 'red',
        partially_refunded: 'red',
      };
      return map[status] || 'grey';
    },
    dateFormatCancelled(value) {
      if (value && (value.reason && value.cancelled_at)) return value.cancelled_at;
      return '';
    },
    reasonFormat(value) {
      if (value?.reason) return value;
      return '';
    },
  },
};
</script>
